import Modal from '../UI/Modal';

import classes from './YesNoSection.module.scss';

export default function YesNoSection({
  logoutFn,
  setModalHidden,
  t,
  language,
}) {
  return (
    <Modal onClose={setModalHidden}>
      <div className={`${classes.modalContainer} ${classes[language]}`}>
        <div className={`${classes['label-container']} ${classes[language]}`}>
          <p className={classes.label}>{t('Are you sure want to log out?')}</p>
        </div>
        <div className={classes['yes-no-button-container']}>
          <button className={classes['yes-no-buttons']} onClick={logoutFn}>
            {t('YES')}
          </button>
          <button
            className={classes['yes-no-buttons']}
            onClick={setModalHidden}
          >
            {t('NO')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
